import { ButtonGroup, styled } from '@mui/material';
import { forwardRef } from 'react';
import Button from 'shell/components/Button';
import Icon from 'shell/components/Icon';

const CustomButtonGroup = styled(ButtonGroup)(({ theme }) => {
    return {
        gap: theme.spacing(1),
        borderRadius: '8px',
        padding: theme.spacing(1),
        background: theme.palette.ensightful.neutral[200],
    };
});

const CustomButton = styled(Button)(({ theme, isSelected, numOptions }) => {
    return {
        width: `calc(100% / ${numOptions})`,
        borderRadius: '4px !important',
        '&:focus-visible': {
            outlineColor: isSelected
                ? theme.palette.ensightful.secondary[100]
                : theme.palette.ensightful.secondary[400],
            outlineWidth: '3px',
            outlineOffset: '-5px',
        },
    };
});

export default forwardRef(({ options, selected, onChange, ...rest }, ref) => {
    if (!options.length) throw new Error(`Shell: options cannot be empty in component ButtonGroup.`);
    if (!selected) throw new Error(`Shell: selected cannot be null in component ButtonGroup.`);

    return (
        <CustomButtonGroup ref={ref} {...rest} disableElevation>
            {options.map((option) => {
                return (
                    <CustomButton
                        key={option.key}
                        color={selected === option.key ? 'primary' : 'neutral'}
                        disabled={option.disabled}
                        isSelected={selected === option.key}
                        numOptions={options.length}
                        startIcon={option.icon ? <Icon kind={option.icon} /> : undefined}
                        variant={selected === option.key ? 'primary' : 'tertiary'}
                        onClick={() => onChange(option.key)}
                    >
                        {option.value}
                    </CustomButton>
                );
            })}
        </CustomButtonGroup>
    );
});
